module.exports = __webpack_public_path__ + "img/Terrassenunterkonstruktion.e4041258.webp";